var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlexibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 80,
    viewBox: "0 0 279 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63004 28.1H3.54004V21.27H8.63004V16.82C8.63004 9.77 12.63 7.44 19.11 7.44C20.93 7.44 22.67 7.52 24.49 7.66V14.78C23.83 14.71 23.18 14.71 22.52 14.71C19.68 14.71 18.67 15.59 18.67 17.84V21.26H24.49V28.09H18.67V60.39H8.63004V28.1ZM28.42 7.88H38.46V60.4H28.42V7.88Z",
    fill: "#010101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.82 42.36V45.49C54.82 50.07 56.0601 54.58 59.7701 54.58C63.12 54.58 64.5 52.04 65.09 47.24H74.1101C73.7501 56.33 69.39 61.43 59.93 61.43C45.38 61.43 44.8 50.23 44.8 40.47C44.8 30 46.84 20.25 60.37 20.25C72.08 20.25 74.7 28.1 74.7 40.11V42.36H54.84H54.82ZM65.0801 36.4C64.8601 30.43 64.1301 27.09 59.9901 27.09C55.8501 27.09 54.82 31.24 54.82 34.88V36.4H65.0801Z",
    fill: "#010101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7601 21.26H109.23L99.0401 40.24L109.67 60.4H99.1901L93.3801 47.6L87.5601 60.4H77.0801L87.7001 40.24L77.5101 21.26H87.9901L93.3801 33.04L98.7601 21.26Z",
    fill: "#010101"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.61 60.4H124.65V21.26H114.61V60.4ZM114.61 16.46H124.65V7.88H114.61V16.46Z",
    fill: "#010101"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.44 7.82001H142.47V24.91H142.62C144.72 21.78 147.27 20.25 151.06 20.25C159.28 20.25 163.06 26.28 163.06 40.83C163.06 55.38 159.28 61.42 151.06 61.42C147.13 61.42 144.37 59.88 142.18 56.25H142.03V60.39H132.43V7.82001H132.44ZM147.78 53.71C152.15 53.71 153.02 49.35 153.02 40.83C153.02 32.31 152.15 27.96 147.78 27.96C143.41 27.96 142.47 32.32 142.47 40.83C142.47 49.34 143.35 53.71 147.78 53.71Z",
    fill: "#010101"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169.89 60.4H179.93V21.26H169.89V60.4ZM169.89 16.46H179.93V7.88H169.89V16.46Z",
    fill: "#010101"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M198.11 7.85999H188.07V60.4H198.11V7.85999Z",
    fill: "#010101"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M206.26 60.4H216.3V21.26H206.26V60.4ZM206.26 16.46H216.3V7.88H206.26V16.46Z",
    fill: "#010101"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M226.26 10.06H236.3V21.27H242.12V28.1H236.3V49.27C236.3 52.33 236.96 53.57 239.87 53.57C240.66 53.57 241.47 53.5 242.12 53.42V60.4C239.94 60.62 237.9 60.83 235.57 60.83C227.71 60.83 226.26 58.43 226.26 50.5V28.09H221.17V21.26H226.26V10.05V10.06Z",
    fill: "#010101"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M246.34 65.71C247.2 65.85 248.08 65.93 248.95 65.93C252.66 65.93 254.05 63.89 254.33 60.4L243.35 21.26H253.82L259.64 48.32H259.78L264.87 21.26H274.91L265.45 57.78C261.96 71.31 259.71 73.2 250.39 73.2H246.33V65.71H246.34Z",
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibility);
export default __webpack_public_path__ + "static/media/flexibility.c7f18baf9ffb2697e9601f4cf61e13e2.svg";
export { ForwardRef as ReactComponent };